var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    "+_vm._s(_vm.productData.c_color)+"\n    "),_c('img',{staticClass:"image",attrs:{"src":_vm.productData.productphoto,"alt":_vm.productData.name},on:{"error":_vm.imageLoadError}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20bd1b66","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./development/js/color.vue
// module id = 44
// module chunks = 0